import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useFormik } from "formik";
import { TextField, Button } from "@packages/ui";
import _ from "lodash";
import SnackBar from "../../layouts/SnackBar";
import { Box } from "@material-ui/core";
import * as rentalActions from "src/actions/rentalActions";

const RentalManageForm = (props) => {
  const { brand, country } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loginState = useSelector((state) => state.rental.login);
  const extensionFlag = useSelector((state) => state.rental.extensionFlag);
  const loginLoading = useSelector((state) => state.rental.loading);
  const eligibleFlag = useSelector((state) => state.rental.eligibleFlag);
  const errorAlertOpen = useSelector((state) => state.rental.errorAlert || false);

  useEffect(() => {
    if (
      loginState &&
      loginState === "success" &&
      !extensionFlag &&
      eligibleFlag &&
      !errorAlertOpen
    ) {
      console.log("eligibleFlag", eligibleFlag);
      navigate(`/rental/manage/booking?brand=${brand}&country=${country}`, { replace: true });
    }
  }, [eligibleFlag]);

  const formik = useFormik({
    initialValues: {
      driverLicenseNumber: "",
      vehicleRegistration: "",
    },
    onSubmit: (values) => {
      console.log("values", values);
      const vehicleRegistration = values.vehicleRegistration.replace(/-/g, "");
      dispatch(
        rentalActions.login({
          country: country.toUpperCase(),
          vehicleRegistration: vehicleRegistration,
          driverLicenseNumber: values.driverLicenseNumber,
        })
      );
    },
    validate: (values) => {
      const errors = {};
      if (!values.driverLicenseNumber) {
        errors.driverLicenseNumber = "Required";
      }
      const regoNoHyphen = values.vehicleRegistration
        ? values.vehicleRegistration.replace(/-/g, "")
        : "";
      if (!values.vehicleRegistration) {
        errors.vehicleRegistration = "Required";
      } else if (regoNoHyphen.length < 5) {
        errors.vehicleRegistration = "Vehicle registration must be at least 5 characters.";
      }
      return errors;
    },
  });

  return (
    <React.Fragment>
      <SnackBar />
      <form onSubmit={formik.handleSubmit}>
        <TextField
          fullWidth
          onChange={formik.handleChange}
          name="driverLicenseNumber"
          label="Driver license number"
          error={formik.errors.driverLicenseNumber ? true : false}
          value={formik.values.driverLicenseNumber}
          helperText={formik.errors.driverLicenseNumber ? formik.errors.driverLicenseNumber : null}
        />
        <TextField
          fullWidth
          onChange={formik.handleChange}
          name="vehicleRegistration"
          label="Vehicle registration"
          error={formik.errors.vehicleRegistration ? true : false}
          value={formik.values.vehicleRegistration}
          helperText={formik.errors.vehicleRegistration ? formik.errors.vehicleRegistration : null}
        />
        <Box style={{ marginTop: 15 }}>
          <Button fullWidth type="submit" loading={loginLoading} title={"Sign In"} />
        </Box>
      </form>
    </React.Fragment>
  );
};

export default RentalManageForm;
